<template>
  <div class="measureMetricsBar"
    v-loading="loading"
  >
    <div class="measureMetricsBar-metric">
      <neb-metric :value="contentCount"
        title="Total Content"
      ></neb-metric>
    </div>

    <div class="measureMetricsBar-metric">
      <neb-metric :value="viewsSum"
        title="Total Views"
      ></neb-metric>
    </div>

    <div class="measureMetricsBar-metric">
      <neb-metric :value="socialActionsSum"
        title="Total Social Actions"
      ></neb-metric>
    </div>

    <div class="measureMetricsBar-metric">
      <neb-metric :value="completionRate"
        title="Avg Completion Rate"
      ></neb-metric>
    </div>

    <div class="measureMetricsBar-metric">
      <neb-metric :value="timeOnContentAvg"
        title="Avg Time on Content"
      ></neb-metric>
    </div>

    <div class="measureMetricsBar-metric">
      <neb-metric :value="conversionsSum"
        title="Total Conversions"
      ></neb-metric>
    </div>
  </div>
</template>

<script>
import {
  abbreviateNumber,
  formatPercent,
  formatDuration
} from '@/helpers'

export default {
  name: 'MeasureMetricsBar',

  props: {
    totalCount: {
      type: [Number, String],
      default: '--'
    },
    metrics: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    contentCount () {
      return abbreviateNumber(this.totalCount)
    },
    viewsSum () {
      return abbreviateNumber(this.metrics.PAGE_VIEWS)
    },
    socialActionsSum () {
      return abbreviateNumber(this.metrics.SOCIAL_ACTIONS)
    },
    completionRate () {
      return formatPercent(this.metrics.AVG_COMPLETION)
    },
    timeOnContentAvg () {
      return formatDuration(this.metrics.AVG_ACTIVE_TIME)
    },
    conversionsSum () {
      return abbreviateNumber(this.metrics.CONVERSIONS)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../Nebula/style.scss';

.measureMetricsBar {
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  padding: 20px 0;
  border: solid 1px $light-grey-blue;
}
</style>
